<template>
  <div>
    <div class="flex items-center justify-between">
      <h2>{{$t('Bins')}}</h2>
      <vs-button v-if="$store.state.AppActiveUser.userRole === 'fc-operations-supervisor'" @click="openBinModal()" color="primary" icon-pack="feather" icon="icon-plus" size="large"></vs-button>
    </div>
    <shipblu-table
      :sst="true"
      orders
      multiple
      v-model="selected"
      pagination
      :max-items="maximumItems"
      :data="bins"
      :tableLoader="tableLoader"
    >
      <template slot="thead">
        <shipblu-th>{{$t('Name')}}</shipblu-th>
        <shipblu-th>{{$t('Capacity')}}</shipblu-th>
        <shipblu-th>{{$t('WRO')}}</shipblu-th>
        <shipblu-th>{{$t('SKU')}}</shipblu-th>
        <shipblu-th>{{$t('No. Products')}}</shipblu-th>
        <shipblu-th>{{$t('Location')}}</shipblu-th>
        <shipblu-th>{{$t('Status')}}</shipblu-th>
        <shipblu-th v-if="$store.state.AppActiveUser.userRole === 'fc-operations-supervisor' || $store.state.AppActiveUser.userRole === 'fc-storing-agent'">{{$t('Actions')}}</shipblu-th>
      </template>

      <template slot-scope="{ data }">
        <shipblu-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" :color="`${getStyle(data[indextr])}`"
          :to="{name: `${$store.state.AppActiveUser.userRole}-bin-logs-view`, params: {binID: data[indextr].id}}">
          <shipblu-td :data="data[indextr].name">
            {{ data[indextr].name }}
          </shipblu-td>

          <shipblu-td :data="data[indextr].capacity">
            {{ data[indextr].capacity }}
          </shipblu-td>

          <shipblu-td :data="data[indextr].wro">
            {{ data[indextr].wro }}
          </shipblu-td>

          <shipblu-td :data="data[indextr].sku">
            {{ data[indextr].sku }}
          </shipblu-td>

          <shipblu-td :data="data[indextr].numberOfPackages">
            {{ data[indextr].number_of_products }}
          </shipblu-td>

          <shipblu-td :data="data[indextr].status" :style="`color: ${getStyle(data[indextr])}`" class="whitespace-nowrap">
            {{ data[indextr].location }}
          </shipblu-td>

          <shipblu-td :data="data[indextr].status" :style="`color: ${getStyle(data[indextr])}`" class="whitespace-nowrap">
            <div class="m-auto flex items-center justify-center font-semibold">
              <div><span class="status-icon mr-1"></span></div>
              <span class="capitalize">{{ $t(getStatusLabel(data[indextr])) }}</span>
            </div>
          </shipblu-td>

          <shipblu-td v-if="$store.state.AppActiveUser.userRole === 'fc-operations-supervisor' || $store.state.AppActiveUser.userRole === 'fc-storing-agent'">
            <div @click="removeAttribute($event)">
              <vs-dropdown
                vs-trigger-click
                class="dd-actions cursor-pointer"
                @click="selected = []"
              >
                <vs-button
                  type="border"
                  size="small"
                  icon-pack="feather"
                  icon="icon-more-horizontal"
                >
                </vs-button>
                <vs-dropdown-menu style="width: 190px">
                  <vs-dropdown-item
                    @click="editBin(data[indextr])"
                  >
                    <span class="flex gap-2 items-center">
                      <feather-icon
                        icon="EditIcon"
                        svgClasses="h-4 w-4"
                      />
                      <span>{{$t('Edit Bin')}}</span>
                    </span>
                  </vs-dropdown-item>
                  <vs-dropdown-item
                    @click="deleteBin(data[indextr])"
                  >
                    <span class="flex gap-2 items-center">
                      <feather-icon
                        icon="TrashIcon"
                        svgClasses="h-4 w-4"
                      />
                      <span>{{$t('Delete Bin')}}</span>
                    </span>
                  </vs-dropdown-item>
                  <vs-dropdown-item :disabled="data[indextr].status === 'stored' || data[indextr].status === 'created'"
                    @click="openProductStore(data[indextr])"
                  >
                    <span class="flex gap-2 items-center">
                      <feather-icon
                        icon="BoxIcon"
                        svgClasses="h-4 w-4"
                      />
                      <span>{{$t('Store SKU')}}</span>
                    </span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
          </shipblu-td>
        </shipblu-tr>
      </template>
    </shipblu-table>
    <add-bins v-if="$store.state.AppActiveUser.userRole === 'fc-operations-supervisor' || $store.state.AppActiveUser.userRole === 'fc-storing-agent' " :binModal="binModal" :binEditing="binEditing"  :binsEditData="binsEditData" @binModal="binModal = $event" @loadBins="loadBins"></add-bins>
    <vs-pagination class="mt-4" :total="Math.ceil(totalRows * 1.0 / maximumItems)" v-model="currentPage"></vs-pagination>
    <store-product-modal :storeProductModal="storeProductModal" @storeProductModal="storeProductModal = $event" :storageData="storageData" @loadBins="loadBins"/>
  </div>
</template>

<script>
import ShipbluTable from '../../layouts/components/ShipBluTable.vue'
import ShipbluTr from '../../layouts/components/ShipBluTr.vue'
import ShipbluTh from '../../layouts/components/ShipBluTh.vue'
import ShipbluTd from '../../layouts/components/ShipBluTd.vue'
import addBins from './components/AddBins.vue'
import common from '@/assets/utils/common'
import {sendFulfillmentRequest} from '../../http/axios/requestHelper.js'
import i18nData from '../../i18n/i18nData.js'
import StoreProductModal from './components/StoreProductModal.vue'

export default {
  components: {
    ShipbluTable,
    ShipbluTr,
    ShipbluTh,
    ShipbluTd,
    addBins,
    StoreProductModal
  },
  data () {
    return {
      maximumItems: process.env.VUE_APP_MAXIMUM_ITEMS_TABLE,
      binModal : false,
      binEditing: false,
      totalRows: 0,
      selected: [],
      currentPage: (this.$route.query.page && Number(this.$route.query.page) > 0) ? Number(this.$route.query.page) : 1,
      offset: 0,
      bins: [],
      deleteData:{},
      binsEditData: {},
      storageData: {},
      tableLoader: false,
      storeProductModal: false
    }
  },
  methods: {
    getStyle (data) {
      return common.getOrderStatusColor(data.status)
    },
    getOrderStatusColor (order) {
      return common.getOrderStatusColor(this.getStatusLabel(order))
    },
    getStatusLabel (order) {
      return common.getStatusLabel(order, this.$store.state.AppActiveUser.userRole)
    },
    removeAttribute (event) {
      event.preventDefault()
    },
    deleteBin (data) {
      this.deleteData = data
      this.$vs.dialog({
        color: 'danger',
        title: 'Confirm',
        text: i18nData[this.$i18n.locale]['Are you sure to delete?'],
        accept: this.confirmDelete
      })
    },
    openProductStore (data) {
      this.storageData = {
        ...data,
        inbounded_quantity: 0
      }
      this.storeProductModal = true
    },
    confirmDelete () {
      sendFulfillmentRequest(false, false, this, `api/v1/fc/bins/${this.deleteData.id}/`, 'delete', null, true,
        () => {
          this.$vs.notify({
            color:'success',
            title:i18nData[this.$i18n.locale]['Success'],
            text:i18nData[this.$i18n.locale]['bin'] + i18nData[this.$i18n.locale][' has been deleted successfully!'],
            position: 'top-center'
          })
          this.loadBins()
        }
      )
    },
    editBin (data) {
      this.binModal = true
      this.binsEditData = data
      this.binEditing = true
    },
    openBinModal () {
      this.binModal = true
      this.binsEditData = {}
      this.binEditing = false
    },
    loadBins () {
      this.tableLoader = true
      const query = `?offset=${this.offset}&limit=${this.maximumItems}`
      sendFulfillmentRequest(true, false, this, `api/v1/fc/bins/${query}`, 'get', null, true,
        (response) => {
          this.bins = response.data.results
          this.totalRows = response.data.count
          this.tableLoader = false
        }
      )
    }
  },
  watch: {
    currentPage () {
      this.offset = (this.currentPage - 1) * this.maximumItems
      this.$router.push({
        query: {
          page: this.currentPage
        }
      }).catch(() => {})
      this.loadBins()
    }
  },
  created () {
    this.offset = (this.currentPage - 1) * this.maximumItems
    this.loadBins()
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";
.con-pagination-table{
  display: none;
}
</style>